// This is generated.  Alter it in blockGroups/formButtons/types/FormButton.js
/* eslint-disable no-unused-vars */
const { actionUtils, config } = require('@sstdev/lib_metadata-config');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(
    hNode,
    context = {},
    parentAccessRestrictions,
  ) {
    const { formAction } = hNode;

    const accessRestrictions = actionUtils.getNodeAccessRestrictions(
      hNode,
      context,
      parentAccessRestrictions,
    );
    if (accessRestrictions.hidden) return [{}, {}];

    // FormButton operates within a form context and triggers form actions (save, cancel, create, etc.)
    // It doesn't define namespace/relation itself - it uses the parent form's context
    // Therefore it returns empty subDataDictionary and partialTypeDefinition

    // The formAction value affects what operations the parent form should support
    // but the actual schema contribution is handled by the form elements, not the button
    return [{}, {}];
  },
};
moduleRegistration.registerHNodeType(
  'formButtons',
  'FormButton',
  module.exports,
);
